export enum Period {
  Yesterday = 'Yesterday',
  Today = 'Today',
  ThisWeek = 'ThisWeek',
  ThisMonth = 'ThisMonth',
}

export const PeriodOptions = [{
  value: Period.Yesterday,
  label: 'Yesterday',
}, {
  value: Period.Today,
  label: 'Today',
}, {
  value: Period.ThisWeek,
  label: 'This week',
}, {
  value: Period.ThisMonth,
  label: 'This month',
}]
